import { render, staticRenderFns } from "./work_task.vue?vue&type=template&id=70bbd5ae&scoped=true&"
import script from "./work_task.vue?vue&type=script&lang=js&"
export * from "./work_task.vue?vue&type=script&lang=js&"
import style0 from "./work_task.vue?vue&type=style&index=0&id=70bbd5ae&scoped=true&lang=less&"
import style1 from "./work_task.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bbd5ae",
  null
  
)

export default component.exports